export const teacherDashboardAr = {
  // Teacher Dashboard specific
  teacherHome: 'الرئيسية',
  quranTracking: 'متابعة القرآن',
  studentProgress: 'تقدم الطلاب',
  teacherMessages: 'الرسائل',
  teacherHomePage: 'الصفحة الرئيسية',
  welcomeTeacher: 'مرحباً بك أستاذ',
  quranTrackingSubtitle: 'متابعة حفظ ومراجعة القرآن الكريم',
  totalStudents: 'إجمالي الطلاب',
  monthlyRecords: 'السجلات الشهرية',
  averageGrade: 'متوسط الدرجات',
  unreadMessages: 'الرسائل غير المقروءة',
  quranTrackingTitle: 'متابعة حفظ القرآن',
  allStudents: 'جميع الطلاب',
  addNewRecord: 'إضافة سجل جديد',
  noStudents: 'لا يوجد طلاب',
  noStudentsFilter: 'لا يوجد طلاب مطابقين للفلتر',
  noRecords: 'لا توجد سجلات متاحة',
  studentProgressTitle: 'تقدم الطلاب في حفظ القرآن',
  memorizationStats: 'إحصائيات الحفظ',
  advancedStudents: 'الطلاب المتقدمون (15+ حزب)',
  intermediateStudents: 'الطلاب المتوسطون (5-14 حزب)',
  beginnerStudents: 'الطلاب المبتدئون (أقل من 5 أحزاب)',
  messagesAndCommunication: 'الرسائل والتواصل',
  addQuranRecord: 'إضافة سجل قرآن جديد',
  editQuranRecord: 'تعديل سجل قرآن',
  loadingStudents: 'جاري تحميل قائمة الطلاب...',
  noStudentsAvailable: 'لا توجد طلاب متاحين',
  noStudentsRegistered: 'لا توجد طلاب مسجلين. يرجى الاتصال بالمدير.',
  add: 'إضافة',
  edit: 'تعديل',
  delete: 'حذف',
  cancel: 'إلغاء',
  save: 'حفظ',
  confirmDelete: 'هل أنت متأكد من حذف هذا السجل؟',
  errorAddingRecord: 'خطأ في إضافة السجل',
  errorDeletingRecord: 'خطأ في حذف السجل',
  errorUpdatingData: 'خطأ في تحديث البيانات',
  sessionExistsToday: 'يوجد بالفعل جلسة لهذا الطالب اليوم، هل تريد تعديل الجلسة الموجودة؟',
  reportSent: 'تم إرسال التقرير بنجاح',
  errorSendingReport: 'خطأ في إرسال التقرير',
  quickReport: 'تقرير سريع',
  reportType: 'نوع التقرير',
  reportMessage: 'الرسالة',
  selectReportType: 'اختر نوع التقرير',
  backToHome: 'العودة للصفحة الرئيسية',
  progressPercentage: 'نسبة التقدم',
  hizbSaved: 'أحزاب محفوظة',
  previousSessions: 'الجلسات السابقة',
  
  // Messages (shared with parent)
  parentMessages: 'رسائل أولياء الأمور',
  noMessages: 'لا توجد رسائل',
  from: 'من:',
  
  // Message priorities
  priorityNormal: 'عادية',
  priorityHigh: 'عالية',
  priorityUrgent: 'عاجلة',
  
  // Report types
  reportTypeAssignment: 'واجب منزلي',
  reportTypeProgress: 'تقرير تقدم',
  reportTypeAchievement: 'إنجاز متميز',
  reportTypeConcern: 'ملاحظة مهمة',
  
  // Sender types
  senderTeacher: 'الأستاذ',
  senderAdmin: 'المدير',
  senderParent: 'ولي الأمر',
  
  // Common
  dateUnknown: '',
  update: 'تحديث',
  
  // Password change
  changePassword: 'تغيير كلمة المرور',
  oldPassword: 'كلمة المرور القديمة',
  newPassword: 'كلمة المرور الجديدة',
  confirmPassword: 'تأكيد كلمة المرور',
  enterOldPassword: 'أدخل كلمة المرور القديمة',
  enterNewPassword: 'أدخل كلمة المرور الجديدة',
  confirmNewPassword: 'أكد كلمة المرور الجديدة',
  passwordChangedSuccess: 'تم تغيير كلمة المرور بنجاح',
  errorChangingPassword: 'خطأ في تغيير كلمة المرور',
  passwordTooShort: 'كلمة المرور يجب أن تكون على الأقل 6 أحرف',
  passwordMismatch: 'كلمات المرور غير متطابقة',
  fillAllFields: 'يرجى ملء جميع الحقول',
  changing: 'جاري التغيير...',
  student: 'الطالب',
  studentLabel: 'الطالب/ـة',
  selectStudent: 'اختر الطالب',
  sendButton: 'إرسال',
  messagePlaceholder: 'اكتب رسالتك هنا...',
  
  // Teacher Dashboard specific stats labels
  presentToday: 'الحاضرون اليوم',
  absentToday: 'الغائبون اليوم',

  // New keys
  associationName: 'جمعية الفلاح',
  teacherBoardSubtitle: 'لوحة الأستاذ',
  welcomeTeacherFemale: 'مرحباً بك أستاذة',
  welcomeTeacherMale: 'مرحباً بك أستاذ',
  examScoresTab: 'نقط الإختبارات',
  replyToMessage: 'إجابة على الرسالة',
  to: 'إلى',
  allAdmins: 'جميع المديرين',
  reportSentToAdmins: 'سيتم إرسال التقرير إلى جميع المديرين',
  reportSentToAdminsAndParent: 'سيتم إرسال التقرير إلى جميع المديرين وأولياء أمور الطالب المحدد',
  reportSentToStudentGuardians: 'سيتم إرسال التقرير إلى أولياء أمور هذا الطالب',
  reportSentToAdminsAndGuardians: 'سيتم إرسال التقرير إلى جميع المديرين وأولياء أمور هذا الطالب',
  addExamScore: 'إضافة نقطة اختبار',
  examDate: 'تاريخ الاختبار',
  subjectLabel: 'المادة',
  gradeLabel: 'الدرجة (من 20)',
  selectSubject: 'اختر مادة',
  notSpecified: 'غير محدد',
  optional: '(اختياري)',
  noSentMessages: 'لا توجد رسائل مرسلة',
  noReceivedMessages: 'لا توجد رسائل مستلمة',
  sentMessages: 'الرسائل المرسلة',
  receivedMessages: 'الرسائل المستلمة',
  administration: 'الإدارة',

  // ExamScoresTable keys
  gradeOutOf20: 'الدرجة (/20)',
  date: 'التاريخ',
  actions: 'الإجراءات',
  noTestScores: 'لا توجد نقط اختبار مسجلة',
  addTestScoreHint: 'اضغط على "إضافة نقطة اختبار" لإضافة نقطة جديدة',
  unknown: 'غير معروف',

  // MessageItem keys
  noSubject: 'بدون موضوع',
  replyBadge: 'رد',
  replyButton: 'إجابة',

  // Alert messages
  noPermissionAdd: 'ليس لديك صلاحية لإضافة نقطة اختبار',
  fillRequiredFields: 'يرجى ملء جميع الحقول المطلوبة',
  invalidGrade: 'يرجى إدخال درجة صحيحة بين 0 و 20',
  examScoreAdded: 'تم إضافة نقطة الاختبار بنجاح',
  examScoreAddFailed: 'فشل في إضافة نقطة الاختبار',
  examScoreAddError: 'حدث خطأ أثناء إضافة نقطة الاختبار',
  noPermissionDelete: 'ليس لديك صلاحية لحذف نقطة اختبار',
  confirmDeleteScore: 'هل أنت متأكد من حذف نقطة الاختبار هذه؟',
  examScoreDeleted: 'تم حذف نقطة الاختبار بنجاح',
  examScoreDeleteFailed: 'فشل في حذف نقطة الاختبار',
  examScoreDeleteError: 'حدث خطأ أثناء حذف نقطة الاختبار',
  selectStudentOrAdmin: 'يرجى اختيار الطالب أو تحديد الإدارة',
  selectStudentRequired: 'يرجى اختيار الطالب',
  loadingDataError: 'خطأ في تحميل البيانات',

  // Quran tracking - colonnes tableau séances précédentes
  quranTableDate: 'التاريخ',
  quranTableNewHifz: 'الحفظ الجديد',
  quranTableOldMurajah: 'مراجعة الحفظ القديم',
  quranTableNewMurajah: 'مراجعة الحفظ القريب',
  quranTableEvalNewHifz: 'تقييم الحفظ',
  quranTableEvalOldMurajah: 'تقييم مراجعة الحفظ القديم',
  quranTableEvalNewMurajah: 'تقييم مراجعة الحفظ القريب',
  quranTableNote: 'الملاحظة',
  quranTableHizb: 'عدد الأحزاب',
  quranHizbLabel: 'حزب محفوظ',
  quranProgressLabel: 'تقدم الحفظ',
  quranProgressPercent: '% من القرآن',
};

